import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { JSX } from 'react';
import styled from 'styled-components';
import { CompactSizeDetailCard } from './components/variants/compact';
import { DefaultSizeDetailCard } from './components/variants/default';
import type { DetailCardProps } from './types';
import { getDetailsCardBackgroundColor, getDetailsCardColor, getDetailsCardOuterPadding } from './utils';
import { colors } from '../../theme/colors';
import { Card } from '../card';
import { StyledCardRibbon } from '../card-ribbon';
import { Padding } from '../padding';
import { Tooltip } from '../tooltip';
export default function DetailCard(props) {
  const $ = _c(71);
  const {
    actions,
    cardProps,
    hoverProps,
    children,
    defaultExpanded: t0,
    eyebrowProps,
    selectableOptions,
    titleColor,
    isHighlighted,
    highlightColor: t1,
    isHovering,
    isExpandable: t2,
    ribbon,
    ribbonVariant,
    testId,
    disabledProps
  } = props;
  const defaultExpanded = t0 === undefined ? false : t0;
  const highlightColor = t1 === undefined ? colors.brand[400] : t1;
  const isExpandableProp = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== disabledProps) {
    t3 = disabledProps || {
      isDisabled: false
    };
    $[0] = disabledProps;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const coalescedDisabledProps = t3;
  const [expanded, setExpanded] = React.useState(defaultExpanded);
  const cardBackgroundColor = cardProps?.backgroundColor || "white";
  const cardHideBorder = cardProps?.hideBorder || false;
  const cardPadding = cardProps?.padding || "default";
  const cardVariant = cardProps?.variant || "default";
  let t4;
  if ($[2] !== cardBackgroundColor || $[3] !== hoverProps?.hoverBackgroundColor || $[4] !== isHighlighted || $[5] !== isHovering) {
    t4 = hoverProps?.hoverBackgroundColor || getDetailsCardBackgroundColor(cardBackgroundColor, {
      isHovering,
      isHighlighted
    });
    $[2] = cardBackgroundColor;
    $[3] = hoverProps?.hoverBackgroundColor;
    $[4] = isHighlighted;
    $[5] = isHovering;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const cardHoverColor = t4;
  const cardTitleColor = hoverProps?.hoverTitleColor || titleColor;
  const hasActions = actions && actions.length > 0;
  const hasChildren = !!children && React.Children.toArray(children).filter(Boolean).length > 0;
  const hasEyebrow = (eyebrowProps?.text?.length ?? 0) > 0;
  const isExpandable = isExpandableProp && hasChildren;
  const isSelectable = !!selectableOptions;
  let t5;
  if ($[7] !== cardHoverColor) {
    t5 = {
      "--nfui-card-background-hover": cardHoverColor
    };
    $[7] = cardHoverColor;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = t5 as React.CSSProperties;
  let t7;
  if ($[9] !== cardBackgroundColor || $[10] !== cardHoverColor || $[11] !== isHighlighted || $[12] !== isHovering) {
    t7 = isHovering ? cardHoverColor : getDetailsCardBackgroundColor(cardBackgroundColor, {
      isHovering,
      isHighlighted
    });
    $[9] = cardBackgroundColor;
    $[10] = cardHoverColor;
    $[11] = isHighlighted;
    $[12] = isHovering;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== cardBackgroundColor || $[15] !== cardHideBorder) {
    t8 = cardHideBorder ? getDetailsCardColor(cardBackgroundColor) : undefined;
    $[14] = cardBackgroundColor;
    $[15] = cardHideBorder;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = cardProps?.hasRadius;
  let t10;
  if ($[17] !== highlightColor || $[18] !== isHighlighted) {
    t10 = isHighlighted ? {
      boxShadow: `inset 6px 0px 0px 0px ${highlightColor}`
    } : undefined;
    $[17] = highlightColor;
    $[18] = isHighlighted;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== cardPadding) {
    t11 = getDetailsCardOuterPadding(cardPadding);
    $[20] = cardPadding;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== cardTitleColor || $[23] !== cardVariant || $[24] !== coalescedDisabledProps || $[25] !== expanded || $[26] !== hasActions || $[27] !== hasEyebrow || $[28] !== isExpandable || $[29] !== isHighlighted || $[30] !== isSelectable || $[31] !== props || $[32] !== testId) {
    t12 = cardVariant === "default" && <DefaultSizeDetailCard {...props} isHighlighted={isHighlighted} isSelectable={isSelectable} expanded={expanded} setExpanded={setExpanded} isExpandable={isExpandable} hasActions={hasActions ?? false} hasEyebrow={hasEyebrow} titleColor={cardTitleColor} testId={testId} disabledProps={coalescedDisabledProps} />;
    $[22] = cardTitleColor;
    $[23] = cardVariant;
    $[24] = coalescedDisabledProps;
    $[25] = expanded;
    $[26] = hasActions;
    $[27] = hasEyebrow;
    $[28] = isExpandable;
    $[29] = isHighlighted;
    $[30] = isSelectable;
    $[31] = props;
    $[32] = testId;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== cardTitleColor || $[35] !== cardVariant || $[36] !== coalescedDisabledProps || $[37] !== expanded || $[38] !== hasActions || $[39] !== hasEyebrow || $[40] !== isExpandable || $[41] !== isHighlighted || $[42] !== isSelectable || $[43] !== props || $[44] !== testId) {
    t13 = cardVariant === "compact" && <CompactSizeDetailCard {...props} isHighlighted={isHighlighted} isSelectable={isSelectable} expanded={expanded} setExpanded={setExpanded} isExpandable={isExpandable} hasActions={hasActions ?? false} hasEyebrow={hasEyebrow} titleColor={cardTitleColor} testId={testId} disabledProps={coalescedDisabledProps} />;
    $[34] = cardTitleColor;
    $[35] = cardVariant;
    $[36] = coalescedDisabledProps;
    $[37] = expanded;
    $[38] = hasActions;
    $[39] = hasEyebrow;
    $[40] = isExpandable;
    $[41] = isHighlighted;
    $[42] = isSelectable;
    $[43] = props;
    $[44] = testId;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  let t14;
  if ($[46] !== ribbon || $[47] !== ribbonVariant) {
    t14 = ribbon && ribbonVariant && <StyledCardRibbon $variant={ribbonVariant}>{ribbon}</StyledCardRibbon>;
    $[46] = ribbon;
    $[47] = ribbonVariant;
    $[48] = t14;
  } else {
    t14 = $[48];
  }
  let t15;
  if ($[49] !== t11 || $[50] !== t12 || $[51] !== t13 || $[52] !== t14) {
    t15 = <Padding size={t11}>{t12}{t13}{t14}</Padding>;
    $[49] = t11;
    $[50] = t12;
    $[51] = t13;
    $[52] = t14;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== t10 || $[55] !== t15 || $[56] !== t7 || $[57] !== t8 || $[58] !== t9) {
    t16 = <StyledDiv><Card hasShadow={false} backgroundColor={t7} borderColor={t8} isRounded={t9} style={t10}>{t15}</Card></StyledDiv>;
    $[54] = t10;
    $[55] = t15;
    $[56] = t7;
    $[57] = t8;
    $[58] = t9;
    $[59] = t16;
  } else {
    t16 = $[59];
  }
  let t17;
  if ($[60] !== t16 || $[61] !== t6 || $[62] !== testId) {
    t17 = <div style={t6} data-testid={testId}>{t16}</div>;
    $[60] = t16;
    $[61] = t6;
    $[62] = testId;
    $[63] = t17;
  } else {
    t17 = $[63];
  }
  const card = t17;
  const {
    isDisabled,
    disabledMessage,
    disabledTooltipProps
  } = coalescedDisabledProps;
  if (isDisabled) {
    let t18;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = {
        position: "relative",
        cursor: "not-allowed",
        background: colors.steel[50],
        opacity: "0.4"
      };
      $[64] = t18;
    } else {
      t18 = $[64];
    }
    let t19;
    if ($[65] !== card) {
      t19 = <div style={t18}>{card}</div>;
      $[65] = card;
      $[66] = t19;
    } else {
      t19 = $[66];
    }
    let t20;
    if ($[67] !== disabledMessage || $[68] !== disabledTooltipProps || $[69] !== t19) {
      t20 = <Tooltip message={disabledMessage} {...disabledTooltipProps}>{t19}</Tooltip>;
      $[67] = disabledMessage;
      $[68] = disabledTooltipProps;
      $[69] = t19;
      $[70] = t20;
    } else {
      t20 = $[70];
    }
    return t20;
  }
  return card;
}
const StyledDiv = styled.div`
  &:hover > div {
    background-color: var(--nfui-card-background-hover);
  }
`;